export default class SeoService {
  /**
   * @desc Represents a SeoService for customization of title, description and h1
   * @constructor
   */
  constructor($rentcarsApi) {
    this.rentcarsApi = $rentcarsApi
  }

  /**
   * @desc returns locality data
   * @param {String} locality
   */
  async seo(params) {
    try {
      const { data } = await this.rentcarsApi.get('v1/seo', params)
      return data.SeoTags
    } catch (e) {
      return null
    }
  }

  /**
   * @desc returns locality data
   * @param {String} locality
   */
  async seoPath(params) {
    try {
      const { data } = await this.rentcarsApi.get('v2/seo', params)
      return data
    } catch (e) {
      return null
    }
  }
}
